import { ProductItem } from "./order";

export interface Estimate {
  id: string;
  customerId: string;
  customerName: string;
  customerRole?: string;
  products: ProductItem[];
  price: string;
  gst: string;
  discount?: string;
  fixing?: string;
  transport?: string;
  total: string;
  notes?: string;
  siteAddress?: string;
  deliveryDate?: string;
  toBeDelivered?: string;
  quotationDate?: string;
  quotationTime?: string;
  terms?: string;
  totalArea?: string;
  showTotalAreaInQuotation?: boolean;
  advance?: string;
  advance2?: string;
  balance?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  convertedOrderId?: string | null;
  convertedAt?: string | null;
  company_name_?: string;
  address_?: string;
  mobile?: string;
}

/** Prefill order form when converting an estimate (no order/estimate id on the order row). */
export function estimateToOrderShapeForConvert(est: Estimate) {
  return {
    status: "new",
    customerId: est.customerId,
    customerName: est.customerName,
    customerRole: est.customerRole,
    products: est.products || [],
    price: est.price,
    gst: est.gst,
    discount: est.discount,
    fixing: est.fixing,
    transport: est.transport,
    total: est.total,
    notes: est.notes,
    siteAddress: est.siteAddress,
    deliveryDate: est.deliveryDate,
    toBeDelivered: est.toBeDelivered,
    quotationDate: est.quotationDate,
    quotationTime: est.quotationTime,
    terms: est.terms,
    totalArea: est.totalArea,
    showTotalAreaInQuotation: est.showTotalAreaInQuotation ?? true,
    advance: est.advance,
    advance2: est.advance2,
    balance: est.balance,
    createdBy: est.createdBy,
    quotation: true,
    invoiceId: "",
    invoiceGenerated: false,
  };
}

export function estimateToOrderShape(est: Estimate) {
  return {
    id: est.id,
    status: "estimate",
    customerId: est.customerId,
    customerName: est.customerName,
    customerRole: est.customerRole,
    products: est.products || [],
    price: est.price,
    gst: est.gst,
    discount: est.discount,
    fixing: est.fixing,
    transport: est.transport,
    total: est.total,
    notes: est.notes,
    siteAddress: est.siteAddress,
    deliveryDate: est.deliveryDate,
    toBeDelivered: est.toBeDelivered,
    quotationDate: est.quotationDate,
    quotationTime: est.quotationTime,
    terms: est.terms,
    totalArea: est.totalArea,
    showTotalAreaInQuotation: est.showTotalAreaInQuotation,
    advance: est.advance,
    advance2: est.advance2,
    balance: est.balance,
    createdBy: est.createdBy,
    createdAt: est.createdAt,
    updatedAt: est.updatedAt,
    invoiceId: "",
    invoiceGenerated: false,
  };
}
